// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './planner/App';

// Tailwind / globalne style
import './index.css';
// DODANE: wysoko-specyficzne poprawki dla dark (FreeDay, itp.)
import './theme/dark-fixes.css';

import ThemeProvider from './theme/ThemeProvider';

// Jednorazowy znacznik po wymuszonym przeładowaniu z service workera. Bez drugiego reloadu.
if (typeof window !== 'undefined') {
    try {
        const current = new URL(window.location.href);
        if (current.searchParams.has('sw')) {
            current.searchParams.delete('sw');
            const next = `${current.pathname}${current.search}${current.hash}`;
            window.history.replaceState(null, '', next);
        }
    } catch {
        // ignore
    }
}

// Rejestracja Service Workera dla Web Push (updateViaCache: 'none' – ważne dla PWA, żeby brał nowe wersje)
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js', { scope: '/', updateViaCache: 'none' })
            .then((registration) => {
                console.log('[Service Worker] Zarejestrowany pomyślnie:', registration.scope);
                registration.update().catch(() => {});
                registration.addEventListener('updatefound', () => {
                    const newWorker = registration.installing;
                    if (newWorker) {
                        newWorker.addEventListener('statechange', () => {
                            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                                console.log('[Service Worker] Nowa wersja dostępna – odśwież, żeby zaktualizować.');
                            }
                        });
                    }
                });
            })
            .catch((error) => {
                console.error('[Service Worker] Błąd rejestracji:', error);
            });
    });
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <React.StrictMode>
        <ThemeProvider>
            <App />
        </ThemeProvider>
    </React.StrictMode>
);
